import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DateSelectors } from "../../components/admin/Common/DateSelectors";
import { BookingsCard } from "../../components/admin/WashBookings/BookingsCard";
import { BookingCard } from "../../components/admin/WashBookings/BookingCard";
import {
  getBooking,
  getBookings,
} from "../../redux/slices/admin.slices/bookings.slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { WashBooking } from "../../types/admin/washBookings.types";
import { NoItemsMessage } from "../../components/admin/Common/NoItemsMessage";

export function WashBookings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { selectedCity } = useSelector((state: RootState) => state.city);
  const { bookings } = useSelector((state: RootState) => state.bookings);

  const today = new Date();
  const [fromDate, setFromDate] = useState<Date | null>(today);
  const [toDate, setToDate] = useState<Date | null>(today);

  const openBooking = (id: string) => {
    navigate(`/admin/bookings/${id}`, {
      preventScrollReset: true,
    });
  };

  const closeBooking = () => {
    navigate("/admin/bookings", {
      preventScrollReset: true,
    });
  };

  const fetchWashBookings = () => {
    dispatch(
      getBookings({
        fromDate: fromDate ? fromDate.toISOString().split("T")[0] : undefined,
        toDate: toDate ? toDate.toISOString().split("T")[0] : undefined,
        city:
          selectedCity?.city === "All cities" ? undefined : selectedCity?.city,
      }) as any
    );
  };

  useEffect(() => {
    if (id) {
      if (!bookings?.find((b) => b?._id === id)?.car?._id) {
        dispatch(getBooking({ ids: [id] }) as any);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchWashBookings();
  }, [fromDate, toDate, selectedCity]);

  return (
    <div className="p-6 relative">
      <h1 className="text-2xl font-bold mb-6">{t("Wash Bookings")}</h1>

      <DateSelectors
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        handleRefresh={fetchWashBookings}
      />

      {bookings && bookings.length > 0 ? (
        <BookingsCard
          bookings={bookings}
          setSelectedWashBookingId={openBooking}
        />
      ) : (
        <NoItemsMessage
          title="No bookings found"
          message="No wash bookings for the selected date and location"
        />
      )}

      {id && bookings?.length > 0 && (
        <BookingCard
          booking={bookings.find((b) => b._id === id) as WashBooking}
          onClose={closeBooking}
        />
      )}
    </div>
  );
}
